import { useKnockSlackClient as b } from "../context/KnockSlackProvider.mjs";
import { useState as t, useCallback as y, useEffect as E } from "react";
import "../../i18n/context/KnockI18nProvider.mjs";
import { useTranslations as I } from "../../i18n/hooks/useTranslations.mjs";
import "swr/infinite";
import { useKnockClient as j } from "../../core/context/KnockProvider.mjs";
import "@knocklabs/client";
import "zustand/shallow";
import "date-fns";
function _({
  slackChannelsRecipientObject: {
    objectId: e,
    collection: a
  }
}) {
  const {
    t: g
  } = I(), o = j(), {
    connectionStatus: h,
    knockSlackChannelId: c
  } = b(), [s, l] = t(null), [i, d] = t(null), [r, C] = t(!1), [S, f] = t(!1), u = y(() => {
    C(!0), (async () => await o.objects.getChannelData({
      collection: a,
      objectId: e,
      channelId: c
    }))().then((n) => {
      var m, k;
      (m = n == null ? void 0 : n.data) != null && m.connections ? l((k = n == null ? void 0 : n.data) == null ? void 0 : k.connections) : l([]), d(null), C(!1);
    }).catch(() => {
      l([]), d(null), C(!1);
    });
  }, [a, o.objects, c, e]);
  return E(() => {
    h === "connected" && !s && !i && !r && u();
  }, [s, u, r, i, h]), {
    data: s,
    updateConnectedChannels: async (p) => {
      f(!0);
      try {
        await o.objects.setChannelData({
          objectId: e,
          collection: a,
          channelId: c,
          data: {
            connections: p
          }
        }), u();
      } catch {
        d(g("slackChannelSetError") || "");
      }
      f(!1);
    },
    updating: S,
    loading: r,
    error: i
  };
}
export {
  _ as default
};
//# sourceMappingURL=useConnectedSlackChannels.mjs.map
